import styled from 'styled-components';
import { body2, spacing, colors, heading1, caption } from 'ui/theme';

export const ChartSection = styled.div`
  display: flex;
`;

export const PieChartContainer = styled.div`
  flex: 2;
  padding: 0 ${spacing.plusHalf};
  // Base chart div
  > div:first-child {
    height: auto;
  }
`;

export const ChartFootnote = styled.div`
  ${caption};
  display: block;
  float: right;
  color: ${colors.textSecondary};
`;

export const TotalCountContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledTotalCountBox = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  border: ${spacing.single} ${colors.grey15} solid;
  margin-left: ${spacing.plusHalf};
  padding: ${spacing.plusHalf};
  > span {
    ${heading1};
  }
`;

export const TotalCountLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const CenterAlignedTooltipText = styled.div`
  text-align: center;
`;
